import React, { FunctionComponent } from 'react';
import { useAssetGroup } from '../assetGroupService';
import { Asset } from '../models/Asset';

type Props = {
    assetGroupId: string;
    asset: Asset;
    onRemove?: (assetId: string) => void;
};

const AssetGroupList: FunctionComponent<Props> = ({ assetGroupId, asset, onRemove }) => {
    const { assetGroup, isLoading, error } = useAssetGroup(assetGroupId);

    if (error) {
        return <div>Kunde inte ladda resursgrupp.</div>;
    }

    if (isLoading || !assetGroup) {
        return <div>Laddar...</div>;
    }

    const handleRemove = (e: React.MouseEvent<HTMLAnchorElement>, assetId: string) => {
        e.preventDefault();
        onRemove?.(assetId);
    };

    return (
        <ul className="mb-3">
            {assetGroup.assets.map(({ assetId, name }) => {
                if (assetId === asset.assetId) {
                    return null;
                }

                return (
                    <li key={assetId}>
                        {name}
                        {onRemove && (
                            <a href={`#${assetId}`} role="button" className="ms-2" onClick={(e) => handleRemove(e, assetId)}>
                                Ta bort
                            </a>
                        )}
                    </li>
                );
            })}
        </ul>
    );
};

export default AssetGroupList;
